var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ChannelsView',{staticClass:"scrollable",attrs:{"data":_vm.$store.state.monitoring.realtime.channels}})}
var staticRenderFns = []

export { render, staticRenderFns }